import { render, staticRenderFns } from "./CustomizeProductBtn.vue?vue&type=template&id=e1b74172&scoped=true&"
import script from "./CustomizeProductBtn.vue?vue&type=script&lang=js&"
export * from "./CustomizeProductBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b74172",
  null
  
)

export default component.exports